import { render, staticRenderFns } from "./Lovelife.vue?vue&type=template&id=a90cfe10&scoped=true&"
var script = {}
import style0 from "./Lovelife.vue?vue&type=style&index=0&id=a90cfe10&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90cfe10",
  null
  
)

export default component.exports